<template>
  <div class="layout-testimonial-card">
    <img class="quote" src="@/assets/big-quote.svg" alt="" />
    <div class="text">
      <slot name="text"></slot>
    </div>
    <div class="about">
      <div class="pic">
        <slot name="pic"></slot>
      </div>
      <div class="about-content">
        <div class="xs-title">
          <slot name="author"></slot>
        </div>
        <div class="caption">
          <slot name="date"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-testimonial-card {
  text-align: left;
}
.text {
  margin-bottom: 2em;
  font-style: italic;
  font-family: 'Cormorant';
  font-size: 1.375em;
  line-height: 170%;
  position: relative;
  z-index: 2;
}
.pic {
  width: 3.75em;
  height: 3.75em;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 1em;
  img {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
  }
}
.quote {
  height: 12em;
  position: relative;
  margin-bottom: -8em;
}
.about {
  display: flex;
  align-items: center;
}
.caption {
  opacity: 0.6;
}
</style>
